.statement {
  font-size: 150%;
  font-style: italic;
  font-weight: 300;
}
